import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";

import Card from "./Components/Card/Card";
import CardForm from "./Components/CardForm/CardForm";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import Login from "./Components/Login/Login";
import PrivateRoute from "./Components/CardForm/PrivateRoute";
import Register from "./Components/Login/Register";
import { ContactUs } from "./Components/Contact/ContactUs";
import { ThankYou } from "./Components/Contact/ThankYou";
import ReceiveInquiry from "./Components/Contact/ReceiveInquiry/ReceiveInquiry";
import Invoice from "./Invoice/Invoice";
import AdvanceInvoice from "./Invoice/AdvanceInvoice";
import ViewAdvanceInvoice from "./Invoice/ViewAdvanceInvoice";
import AdminPanel from "./Pdf/AdminPanel/AdminPanel";
import FlipbookViewer from "./Pdf/AdminPanel/FlipbookViewer/FlipbookViewer";
import QrGenerator from "./Qrcode/Qr";
import Navbar from "./Components/Navbar/Navbar";
import PerformaInvoice from "./Invoice/PerformaInvoice";


function App() {
  return (
    <div className="App">
      {/* <Navbar/> */}
      <Routes>
      <Route path="/invoice" element={<Invoice/>} />
      <Route path="/pr-invoice" element={<PerformaInvoice/>} />

        
        {/* <Route path="/:slug" element={<Card/>} />
        <Route path="/card" element={<CardForm/>} />
        <Route path="/admin" element={<AdminDashboard/>} /> */}


        {/* <Route path="/register" element={<Register/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/thank-you" element={<ThankYou/>} />
      
        <Route path="/" element={<QrGenerator/>} />

        <Route path="/1" element={<AdvanceInvoice/>} />
        <Route path="/view-advance-invoice" element={<ViewAdvanceInvoice/>} />
        <Route path="/pdfadmin" element={<AdminPanel/>} />
        <Route path="/flipbook/:flipbookId" element={<FlipbookViewer/>} /> */}




      



        <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <ReceiveInquiry/>
              </PrivateRoute>
            }
          />

      </Routes>
    </div>
  );
}

export default App;
